import * as React from 'react';

import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'components/lib/utils';

const flexVariants = cva('flex', {
  variants: {
    direction: {
      row: 'flex-row',
      column: 'flex-col',
      'row-reverse': 'flex-row-reverse',
      'column-reverse': 'flex-col-reverse'
    },
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch',
      baseline: 'items-baseline'
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly'
    },
    wrap: {
      true: 'flex-wrap',
      false: 'flex-nowrap'
    }
  },
  defaultVariants: {
    direction: 'column'
  }
});

export interface FlexProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof flexVariants> {}

const Flex = React.forwardRef<HTMLDivElement, FlexProps>(
  ({ className, direction, align, justify, wrap, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        flexVariants({ direction, align, justify, wrap }),
        className
      )}
      {...props}
    />
  )
);
Flex.displayName = 'Flex';

export { Flex, flexVariants };
